<template>
  <ProductEngraving :engraving="outsideEngraving" />
</template>

<script lang="ts" setup>
import { useProductInject } from '../../../context/useProductContext'
import ProductEngraving from './ProductEngraving.vue'
const { outsideEngraving } = useProductInject()
</script>